/** Normalize plan API row (camelCase or snake_case). */
export function planNum(plan, snake, camel, fallback = 0) {
  const raw = plan?.[snake] ?? plan?.[camel];
  const n = parseFloat(String(raw ?? ""));
  return Number.isFinite(n) ? n : fallback;
}

export function planStr(plan, snake, camel, fallback = "") {
  const raw = plan?.[snake] ?? plan?.[camel];
  return raw != null && raw !== "" ? String(raw) : fallback;
}

export function isPlanPopular(plan) {
  const v = plan?.popular;
  return v === 1 || v === "1" || v === true;
}

export function isPlanFree(plan) {
  return planNum(plan, "price", "price", 0) <= 0;
}
